import {
    USUARI_INICIALITZAR,
    USUARI_OMPLIR_USUARIS
} from '../../actions/actionTypes';

const ESTAT_INICIAL = {};

const tots = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_OMPLIR_USUARIS:
            return action.usuaris;

        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/usuari/tots.js